import { createPersistentItem } from '@amazon/vinyl-util'
import { number, object, string, type ObjectSchema } from '@amazon/vinyl-validation'
import { type AuthTokenWithRefresh } from '@amzn/vinyl-amzn'

export const authTokenValidator: ObjectSchema<AuthTokenWithRefresh> = object({
    refreshToken: string(),
    expiresAt: number(),
    accessToken: string(),
})

export const localSignInPersistence = createPersistentItem<AuthTokenWithRefresh | null>({
    key: 'auth',
    defaultValue: null,
    validator: authTokenValidator.orNull().assert,
})
